// extracted by mini-css-extract-plugin
module.exports = {"userItem":"userItem--3ZOIG","email":"email--1_0dd","firstName":"firstName--2OQwR","lastName":"lastName--nM8WS","action":"action--2HRuR","deleteButton":"deleteButton--C3bG3"};